var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMessengerLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.67534 22.1231C4.18645 19.6112 3.66565 16.6421 4.21072 13.7733C4.75579 10.9046 6.32925 8.33341 8.63569 6.54255C10.9421 4.75169 13.823 3.86428 16.7373 4.04692C19.6517 4.22957 22.3992 5.4697 24.464 7.53451C26.5288 9.59932 27.7689 12.3468 27.9516 15.2612C28.1342 18.1755 27.2468 21.0563 25.4559 23.3628C23.6651 25.6692 21.0939 27.2427 18.2252 27.7878C15.3564 28.3328 12.3873 27.812 9.87534 26.3231V26.3231L5.72534 27.4981C5.55531 27.5479 5.37503 27.5509 5.20341 27.507C5.03178 27.4631 4.87513 27.3739 4.74986 27.2486C4.6246 27.1234 4.53534 26.9667 4.49144 26.7951C4.44753 26.6234 4.45061 26.4432 4.50034 26.2731L5.67534 22.1231Z",
    fill: "#7603FE",
    stroke: "#7603FE",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 18L14 14L18 18L22 14",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessengerLogo);
export default __webpack_public_path__ + "static/media/MessengerLogo.bb893032f38e7b01e96f56908ae707b7.svg";
export { ForwardRef as ReactComponent };